/**
 * Payments API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import {
  createPayment,
  deletePayment,
  getPaymentById,
  getPayments,
  permanentDeletePayment,
  restorePayment,
  updatePayment,
} from "../generated/payments/payments";

import { wrapListMethod, wrapMethod } from "./utils";

export const payments = {
  /** @see createPayment */
  create: wrapMethod(createPayment),

  /** @see getPayments */
  list: wrapListMethod(getPayments),

  /** @see getPaymentById */
  get: wrapMethod(getPaymentById),

  /** @see updatePayment */
  update: wrapMethod(updatePayment),

  /** @see deletePayment */
  delete: wrapMethod(deletePayment),

  /** @see restorePayment */
  restorePayment: wrapMethod(restorePayment),

  /** @see permanentDeletePayment */
  permanentDeletePayment: wrapMethod(permanentDeletePayment),
} as const;

export type PaymentsApi = typeof payments;
